export default "__VITE_ASSET__ChZuGhaQ__"